module.exports = __webpack_public_path__ + "img/21.8cc7252.png";